const state = {
    active: 'dark'
};

const mutations = {
    toggle(state){
        state.active = (state.active === 'light') ? 'dark' : 'light';
    }
};

const actions = {
    toggle({commit}){
        commit('toggle');
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
